module.exports = __webpack_public_path__ + "img/sdmsolucionweb.fad66d8b.png";